import { SearchFilter } from '@aibees/elephant/feature/search-filters/types';
import { Maybe } from '@aibees/shared/definition';

export interface TimeFrameSelectProps {
  className?: string;
  filter: SearchFilter;
  value?: string;
  onChange?: (value: Maybe<string>) => void;
}

export enum TimeFrames {
  UNDEFINED = 'UNDEFINED',
  THREE = 'THREE',
  SIX = 'SIX',
  TWELVE = 'TWELVE',
  TWENTY_FOUR = 'TWENTY_FOUR',
}
